// extracted by mini-css-extract-plugin
export var messageSideLeft = "_i4-1";
export var messageSideRight = "_i4-2";
export var orderLookupBubbleContainer = "_i4-0";
export var submitButton = "_i4-3";